import { IPersistenceContainer } from '../../abstracts/persistence.container';

const /** @type {?} */ NULL_VALUE = '_____NULL_VALUE_____';
/**
 * This is a container that wraps a browser storage object.
 * 
 * @export
 * \@class BrowserContainer
 * 
 * @author Scott O'Bryan
 * \@since 1.0
 */
export class BrowserContainer implements IPersistenceContainer {
/**
 * Creates an instance of BrowserContainer.
 * @param {?} _storage
 */
constructor(private _storage: Storage) {
    }
/**
 * Sets a value on the browser storage
 * 
 * @param {?} key
 * @param {?} value
 * @return {?}
 */
public set(key: string, value: any): boolean {
        try {
            if (value === null) {
                value = NULL_VALUE;
            }

            if (value === undefined) {
                this._storage.removeItem(key);
            } else {
                this._storage.setItem(key, JSON.stringify(value));
            }
        } catch ( /** @type {?} */error) {
            return false;
        }

        return true;
    }
/**
 * Gets a value from browser storage
 * 
 * @param {?} key
 * @return {?}
 */
public get(key: string): any {
        let /** @type {?} */ strval = this._storage.getItem(key);

        if (strval === null) {
            return undefined;
        }

        let /** @type {?} */ value = JSON.parse(strval);

        if (value === NULL_VALUE) {
            return null;
        }

        return value;
    }
/**
 * Removes a value from browser storage
 * 
 * @param {?} key
 * @return {?}
 */
public remove(key: string): any {
        let /** @type {?} */ curVal = this.get(key);

        if (curVal !== undefined) {
            this._storage.removeItem(key);
        }

        return curVal;
    }
/**
 * Removes all values from browser storage
 * @return {?}
 */
public removeAll(): void {
        this._storage.clear();
    }
}

function BrowserContainer_tsickle_Closure_declarations() {
/** @type {?} */
BrowserContainer.prototype._storage;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
